import { MutationTree } from "vuex";
import { CompanyAdminzoneState } from "@/types/store/adminzone";
import { CompanyData } from "@/types";
import Vue from "vue";

export const mutations: MutationTree<CompanyAdminzoneState> = {
  SET_COMPANIES: (state, payload: Array<CompanyData>): Array<CompanyData> => Vue.set(state, 'companies', payload)
}
